import { BrowserRouter, Navigate, Route, Routes, Outlet, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { LoginPage } from './pages/LoginPage';
import { MarketplacePage } from './pages/MarketplacePage';
import { FlowDetailPage } from './pages/FlowDetailPage';
import { FlowFormPage } from './pages/FlowFormPage';
import { AdminPendingPage } from './pages/AdminPendingPage';
import { AdminDashboardPage } from './pages/AdminDashboardPage';
import { AccountPreferencesPage } from './pages/AccountPreferencesPage';
import { NodeDesignerPage } from './pages/NodeDesignerPage';
import { FaqPage } from './pages/FaqPage';
import { OidcCallbackPage } from './pages/OidcCallbackPage';
import { MyEntriesPage } from './pages/MyEntriesPage';
import { ForumPage } from './pages/ForumPage';
import { ForumThreadPage } from './pages/ForumThreadPage';
import { Layout } from './components/Layout';
import { AdminReportsPage } from './pages/AdminReportsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ExtensionConnectPage } from './pages/ExtensionConnectPage';
import { TeamsPage } from './pages/TeamsPage';
import { TeamDetailPage } from './pages/TeamDetailPage';
import { TeamRequestPage } from './pages/TeamRequestPage';
import { AIDesignerPage } from './pages/AIDesignerPage';
import { AdminFeatureFlagsPage } from './pages/AdminFeatureFlagsPage';
import { AdminValidatorConfigPage } from './pages/AdminValidatorConfigPage';
import { ExtensionChangelogPage } from './pages/ExtensionChangelogPage';
import { CustomNodesPage } from './pages/CustomNodesPage';
import { CustomNodeDetailPage } from './pages/CustomNodeDetailPage';
import { CustomNodeFormPage } from './pages/CustomNodeFormPage';
import { CustomNodesWhatsNewPage } from './pages/CustomNodesWhatsNewPage';

function RequireAuth() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="loading loading-full">Validating session…</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/oidc/callback" element={<OidcCallbackPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route element={<RequireAuth />}>
              <Route element={<Layout />}>
              <Route index element={<MarketplacePage />} />
              <Route path="/my" element={<MyEntriesPage />} />
              <Route path="/flows/new" element={<FlowFormPage mode="create" />} />
                <Route path="/flows/:id" element={<FlowDetailPage />} />
                <Route path="/flows/:id/edit" element={<FlowFormPage mode="edit" />} />
                <Route path="/account/preferences" element={<AccountPreferencesPage />} />
                <Route path="/designer" element={<NodeDesignerPage />} />
                <Route path="/admin/dashboard" element={<AdminDashboardPage />} />
                <Route path="/admin/pending" element={<AdminPendingPage />} />
                <Route path="/admin/reports" element={<AdminReportsPage />} />
                <Route path="/admin/feature-flags" element={<AdminFeatureFlagsPage />} />
                <Route path="/admin/validator-config" element={<AdminValidatorConfigPage />} />
                <Route path="/teams" element={<TeamsPage />} />
                <Route path="/teams/request" element={<TeamRequestPage />} />
                <Route path="/teams/:id" element={<TeamDetailPage />} />
                <Route path="/forum" element={<ForumPage />} />
                <Route path="/forum/:id" element={<ForumThreadPage />} />
                <Route path="/faq" element={<FaqPage />} />
                <Route path="/extension/connect" element={<ExtensionConnectPage />} />
                <Route path="/extension/changelog" element={<ExtensionChangelogPage />} />
                <Route path="/ai-designer" element={<AIDesignerPage />} />
                <Route path="/custom-nodes" element={<CustomNodesPage />} />
                <Route path="/custom-nodes/whats-new" element={<CustomNodesWhatsNewPage />} />
                <Route path="/custom-nodes/new" element={<CustomNodeFormPage mode="create" />} />
                <Route path="/custom-nodes/:id" element={<CustomNodeDetailPage />} />
                <Route path="/custom-nodes/:id/edit" element={<CustomNodeFormPage mode="edit" />} />
              </Route>
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
